import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sparkles, Loader2 } from 'lucide-react';
import { ambassadorLogin } from '../api';

const AmbassadorLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const res = await ambassadorLogin(email, password);
      localStorage.setItem('pe_amb_token', res.token);
      navigate('/ambassador/dashboard');
    } catch (er) {
      setErr(er?.response?.data?.detail || 'Login failed.');
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-40 pb-40 min-h-screen">
      <form onSubmit={submit} className="max-w-sm mx-auto px-5 card-glass rounded-2xl p-8">
        <Sparkles className="h-8 w-8 text-[#f0d582] mx-auto mb-4" />
        <h1 className="font-cinzel text-2xl text-gold-gradient text-center">Ambassador Login</h1>
        <p className="font-jost text-xs text-[#f5ecd9]/50 text-center mt-2 mb-6">Approved ambassadors only.</p>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-white/5 border border-[#d4af37]/30 rounded-md px-4 py-3 text-sm text-[#f5ecd9] focus:outline-none focus:border-[#ff4da6] mb-3" />
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full bg-white/5 border border-[#d4af37]/30 rounded-md px-4 py-3 text-sm text-[#f5ecd9] focus:outline-none focus:border-[#ff4da6]" />
        {err && <p className="text-[#ff4da6] text-xs mt-3 font-jost">{err}</p>}
        <button type="submit" disabled={loading} className="btn-gold w-full mt-5 flex items-center justify-center gap-2 rounded-md py-3 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37] disabled:opacity-60">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Log In'}</button>
        <p className="text-center font-jost text-sm text-[#f5ecd9]/50 mt-5">Not an ambassador yet? <Link to="/ambassador" className="text-[#f0d582] hover:text-[#ff4da6] underline">Apply here</Link></p>
      </form>
    </div>
  );
};

export default AmbassadorLogin;
